<template>
  <div class="form-group-container d-flex flex-wrap justify-content-between">
    <div class="form-group form-1-3">
      <label for="ChildName" class="control-label ">Child's name</label>
      <input
        type="text"
        id="ChildName"
        class="form-control"
        required
        placeholder="E.g David Oshinaga"
        v-model="child_name"
        @change="updateForm('name', child_name)"
      />
    </div>

    <div class="form-group form-1-3">
      <label for="ChildClass" class="control-label">Child's class</label>
      <select
        class="form-control"
        id="class"
        v-model="child_class"
        @change="updateForm('class', child_class)"
        required
      >
        <option value selected disabled>
          Child Class
        </option>
        <option
          v-for="(childclass, index) in class_list"
          :key="index"
          :value="childclass.id"
          >{{ childclass.description }}</option
        >
      </select>
    </div>

    <div class="form-group form-1-3">
      <multi-select-2
        :selections="summer_courses"
        label="Select courses"
        placeholder="Add new course"
        required
        @selectionUpdate="updateForm('course', $event)"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import MultiSelect2 from "@/components/globalComps/MultiSelect2";

export default {
  name: "SummerSchoolChildForm",

  components: { MultiSelect2 },

  mounted() {
    this.fetchClassList();
    this.fetchSummerCourses();
  },

  data() {
    return {
      child_name: "",
      child_class: "",
      class_list: [],
      summer_courses: [],
      child_form: {},
    };
  },

  methods: {
    ...mapActions(["getGlobalClassList", "getSummerSchoolCourses"]),

    fetchClassList() {
      this.getGlobalClassList().then((response) => {
        if (response.code === 200) this.class_list = response.data;
      });
    },

    fetchSummerCourses() {
      this.getSummerSchoolCourses(1).then((response) => {
        if (response.code === 200) {
          this.summer_courses = response.data.courses;
        }
      });
    },

    updateForm(type, data) {
      if (type === "name") {
        let child_fullname = data.trim().split(" ");

        //filter out only valid names
        let name_list = child_fullname.filter((name) => {
          return name;
        });

        this.child_form.first_name = name_list[0]; // make first name in the list the firstname
        this.child_form.last_name = name_list.pop(); // use last name in the list as last name
        this.$emit("updateform", this.child_form);
      }
      if (type === "course") {
        this.child_form.course_id = data;
        this.$emit("updateform", this.child_form);
      }
      if (type === "class") {
        this.child_form.class = data;
        this.$emit("updateform", this.child_form);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.form-group-container {
  margin-bottom: 20px;

  .form-1-3 {
    width: 32%;
    margin-bottom: 0;
    &:last-child {
      margin-bottom: 0;
    }
    @include breakpoint_max(lg) {
      width: 100%;
      margin-bottom: 20px;
    }
  }
}

.onboarding-instruction {
  font-size: 12px;
  line-height: 165%;
  margin-bottom: 20px;
  color: $color_ash;
}

.control-label {
  text-transform: none;
  font-weight: 600;
  color: $color_text;
}
</style>
